import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Panfletos from "@/pages/Panfletos";
import PanfletoPromocional from "@/pages/PanfletoPromocional";
import PanfletoPrecos from "@/pages/PanfletoPrecos";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/panfletos" element={<Panfletos />} />
          <Route path="/panfletos/promocional" element={<PanfletoPromocional />} />
          <Route path="/panfletos/precos" element={<PanfletoPrecos />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </div>
  );
}

export default App;
